"use client";

import {useTransition} from "react";

export function AuthControls({signedIn}: {signedIn: boolean}) {
    const [isPending, startTransition] = useTransition();

    if (!signedIn) {
        return (
            <a className="button button-primary" href="/api/auth/discord/login?redirect=/lobbies/new">
                Sign in with Discord
            </a>
        );
    }

    return (
        <button
            className="button button-ghost"
            disabled={isPending}
            onClick={() => {
                startTransition(async () => {
                    await fetch("/api/auth/logout", {method: "POST"});
                    window.location.href = "/";
                });
            }}
            type="button"
        >
            {isPending ? "Signing out..." : "Sign out"}
        </button>
    );
}
